import styled from "styled-components";
import { AnimationCommonCardListWrapper, beforeCss } from "../../atom";
import { InputNumber } from "@renderbus/ui";

export const QingCloudRechargeWrapper = styled.div`
  border: 1px solid #495359;
  background: #212327;
  border-radius: 4px;
  padding: 0 16px 14px;
  .rule-text {
    text-align: right;
    line-height: 42px;
  }
  .qing-cloud-card-list-wrapper {
    overflow: hidden;
  }
`;
export const QingCloudWrapper = styled.div`
  /* margin-top: 16px; */
`;

export const CardListContent = styled.div`
  position: relative;
  .scroll-button {
    position: absolute;
    cursor: pointer;
    top: 0;
    bottom: 0;
    margin: auto 0;
    z-index: 10;
  }
  .left-button {
    left: -30px;
  }
  .right-button {
    right: -30px;
  }
`;

export const QingCloudCardList = styled(AnimationCommonCardListWrapper)`
  width: max-content;
  padding-right: 10px;
`;

export const QingCloudCard = styled.div<{ isActive: boolean }>`
  position: relative;
  width: 224px;
  height: 134px;
  background: ${(p) => (p.isActive ? "rgba(19, 203, 117, 0.04)" : "#292B2F")};
  box-shadow: inset 0 0 0 1px rgba(73, 83, 89, 1);
  border-radius: 8px;
  padding: 20px 11px 18px 14px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  gap: 4px;
  ${(p) => p.isActive && beforeCss}
  .recharge-price {
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 16px;
    height: 42px;
    width: 100%;
    .price {
      font-size: 30px;
    }
  }
  .extra-welfare {
    .tip-text {
      color: #ffffff;
      height: 20px;
      width: 100%;
      margin-bottom: 6px;
    }
    .gift-amount {
      padding: 0 8px;
      font-size: 14px;
      line-height: 26px;
      color: #ffffff;
      background: ${(p) =>
        p.isActive ? "rgba(19, 203, 117, 0.15)" : "rgba(255, 255, 255, 0.06)"};
      border-radius: 20px;
      display: flex;
      align-items: center;
      width: 100%;
      svg {
        margin-right: 6px;
        fill: ${(p) => (p.isActive ? "var(--main-color)" : "#727E84")};
      }
    }
  }
  :hover {
    background: rgba(19, 203, 117, 0.04);
    ${beforeCss};
    .gift-amount {
      background: rgba(19, 203, 117, 0.15);
      svg {
        fill: var(--main-color);
      }
    }
  }
`;

export const CpuQingCloudWrapper = styled.div`
  margin-top: 16px;
`;

export const InputNumberWrapper = styled(InputNumber)`
  width: 224px !important;
  height: 40px;
  line-height: 40px;
  margin: 6px 0 4px;
  background: #212327 !important;
  border: 1px solid #495359 !important;
  border-radius: 8px !important;
  box-shadow: unset;
  &:hover {
    border: 1px solid #13cb75 !important;
    box-shadow: unset !important;
  }
  &:focus-within {
    box-shadow: unset;
  }
  .ant-input-number-input {
    height: 100% !important;
  }
  &.ant-input-number-status-error {
    border: 1px solid #ff4d4f !important;
  }
`;
